module.exports = __webpack_public_path__ + "./Ting-Yu_2bee5b5f29506fdc48fb3f3135d16384.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/Ting-Yu.jpg
// module id = 508
// module chunks = 0